import React from 'react';
import { Cog, Scale, Heart, GraduationCap, Building, HandHeart } from 'lucide-react';
import { industries } from '../data/mock';

const iconMap = {
  Cog: Cog,
  Scale: Scale,
  Heart: Heart,
  GraduationCap: GraduationCap,
  Building: Building,
  HandHeart: HandHeart
};

const Industries = () => {
  return (
    <section id="industries" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="flex flex-wrap items-center justify-between gap-6 mb-12">
          <div>
            <span className="text-[#0077B6] font-semibold tracking-wider text-sm uppercase">Industry Expertise</span>
            <h2 className="text-[#0a2342] text-3xl md:text-4xl font-bold mt-2">
              Specialized Solutions for<br className="hidden md:block" />
              Complex Industry Requirements
            </h2>
          </div>
          <a
            href="#contact"
            className="px-8 py-3.5 bg-[#0077B6] text-white font-semibold rounded-full hover:bg-[#005f8f] transition-colors uppercase tracking-wide text-sm"
          >
            Learn More
          </a>
        </div>

        {/* Industries Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {industries.map((industry) => {
            const IconComponent = iconMap[industry.icon];
            return (
              <div
                key={industry.id}
                className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group"
              >
                <div className="p-6">
                  {/* Icon Box */}
                  <div className="w-20 h-20 bg-[#0077B6] rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                    {IconComponent && <IconComponent className="text-white" size={36} />}
                  </div>
                  <h3 className="text-[#0a2342] text-xl font-bold mb-3">{industry.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-4">{industry.description}</p>
                  <a
                    href="#"
                    className="text-[#0077B6] font-semibold text-sm hover:underline"
                  >
                    Read More →
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Industries;
